import { ref, computed, onMounted, onUnmounted, watch } from 'vue';

export function useContainerWidth(widgetId, widgetType, widgetMode) {
    // функция для замены медиа-запросов и vue-mq на зависимость от ширины контейнера

    // для витрины и баннера зависимость от конейнера, куда встраивается контент
    // для попапов нужно только для превью (переключение на мобилку), при встраивании на сайт позиционируется относительно окна

    const container = ref(null);
    const containerWidth = ref(0);

    // md > 1280 mq - контейнер 1232
    // sm > 768 - контейнер макс 704px
    // xs > 320
    // xxs < 320

    const isMobile = computed(() => containerWidth.value <= 702);
    const isTablet = computed(() => containerWidth.value < 1232 && containerWidth.value >= 702);
    const isDesktop = computed(() => containerWidth.value >= 1232);
    const isAdaptive = computed(() => containerWidth.value >= 320 && containerWidth.value < 1232);

    const isPreview = computed(() => widgetMode === 'preview');

    const containerId = () => {
        if (isPreview.value) {
            return `#${widgetType}`;
        }
        return `#${widgetType}-${widgetId}`;
    };

    const updateContainerWidth = () => {
        containerWidth.value = container.value ? container.value.offsetWidth : window.innerWidth;
    };

    onMounted(() => {
        // при монтировании виджета определяется контейнер, в который встраивается виджет
        const containerPreview = document.querySelector('.widget-market-preview__frame');

        if (widgetType === 'embedded-showcase' || widgetType === 'banner') {
            container.value = document.querySelector(containerId());
        } else {
            // для попапов позиционирование относительно окна либо превью-контейнера
            container.value = containerPreview && isPreview ? containerPreview : null;
        }

        updateContainerWidth();
        window.addEventListener('resize', updateContainerWidth);

        // для превью чекаем переключение на мобилку (по присваиванию класса) и обновляем ширину контейнера
        if (containerPreview) {
            const observer = new MutationObserver(() => {
                updateContainerWidth();
            });
            observer.observe(containerPreview, { attributes: true, attributeFilter: ['class'] });
        }
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateContainerWidth);
    });

    watch(containerWidth, () => {
        updateContainerWidth();
    });

    return {
        containerRef: container,
        containerWidth,
        isMobile,
        isTablet,
        isDesktop,
        isAdaptive,
        updateContainerWidth,
    };
}